<div class="modal-header">
    <h4 class="modal-title">{{ options.title }}</h4>
</div>
<div class="modal-body">
    <p [innerHTML]="options.message | safeHTML"></p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-cancel" (click)="no()">
        {{ 'no' | label: 'general' | async }}
    </button>
    <button type="button" class="btn btn-progreso" (click)="yes()">
        {{ 'yes' | label: 'general' | async }}
    </button>
</div>